import { Popconfirm, Switch, Tooltip } from "antd"

type Props = {
  value: boolean
  onChange: (value: boolean) => void
  canEditGroupFields: boolean
  hasInvoices: boolean
  isApproved: boolean
}

const ApprovalStateSwitch = ({value, onChange, canEditGroupFields, hasInvoices, isApproved}: Props) => {
  if (!canEditGroupFields) {
    return <Tooltip title="This can only be changed at the group level.">
      <Switch 
        value={value}
        disabled
      />
    </Tooltip>
  }

  if (hasInvoices && isApproved) {
    return <Popconfirm
      title="This has already been invoiced. Are you sure you want to mark it unapproved?"
      okText="Mark Unapproved"
      onConfirm={() => onChange(!value)}
    >
      <Switch value={value} />
    </Popconfirm>
  }

  return <Switch 
    value={value}
    onChange={onChange}
  />
}

export default ApprovalStateSwitch